import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import {
  fetchAllUserTransactions,
  fetchCurrentUser,
  fetchCurrentUserGroups,
  fetchLandingPageListings,
} from '../../ducks/user.duck';
import { saveShopifyDetails } from '../../ducks/auth.duck';
import { searchGroups } from '../GroupSearchPage/GroupSearchPage.duck';
import { queryUserListings } from '../ProfilePage/ProfilePage.duck';
export const ASSET_NAME = 'landing-page';


export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };

  return dispatch(fetchCurrentUser())
    .then(() => {
      const userId = getState().user?.currentUser?.id?.uuid;
      const currentUserTasks = userId
        ? [
            dispatch(saveShopifyDetails(search)),
            dispatch(queryUserListings(userId, config)),
            dispatch(fetchAllUserTransactions()),
            dispatch(fetchCurrentUserGroups()),
          ]
        : [];

      return Promise.all([
        dispatch(fetchPageAssets(pageAsset, true)),
        dispatch(searchGroups({ page: 1 })),
        dispatch(fetchLandingPageListings({
          minStock: 1,
          page: 1,
          perPage: 6,
        })),
        ...currentUserTasks,
      ]);
    })
    .then(() => {
      return {};
    })
    .catch(e => {
      throw e;
    });
};
